import type { BaseTranslation } from '../../i18n-types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const cs_countries = {
	AFG: 'Afghánská islámská republika',
	ALA: 'Provincie Alandy',
	ALB: 'Albánie',
	DZA: 'Alžírská demokratická a lidová republika',
	ASM: 'Území Americká Samoa',
	VIR: 'Americké Panenské ostrovy',
	AND: 'Andorra',
	AGO: 'Angolská republika',
	AIA: 'Anguilla',
	ATA: 'Antarktida',
	ATG: 'Antigua a Barbuda',
	ARG: 'Argentinská republika',
	ARM: 'Arménie',
	ABW: 'Aruba',
	AUS: 'Australské společenství',
	AZE: 'Ázerbájdžán',
	BHS: 'Bahamské společenství',
	BHR: 'Království Bahrajn',
	BGD: 'Bangladéšská lidová republika',
	BRB: 'Barbados',
	BEL: 'Belgie',
	BLZ: 'Belize',
	BLR: 'Běloruská republika',
	BEN: 'Beninská republika',
	BMU: 'Bermudy',
	BTN: 'Bhútánské království',
	BOL: 'Mnohonárodní stát Bolívie',
	BES: 'Bonaire, Svatý Eustach a Saba',
	BIH: 'Bosna a Hercegovina',
	BWA: 'Botswanská republika',
	BVT: 'Bouvetův ostrov',
	BRA: 'Brazilská federativní republika',
	IOT: 'Britské území v Indickém oceánu',
	VGB: 'Britské Panenské ostrovy',
	BRN: 'Stát Brunej Darussalam',
	BGR: 'Bulharsko',
	BFA: 'Burkina Faso',
	BDI: 'Burundská republika',
	COK: 'Cookovy ostrovy',
	CUW: 'Země Curaçao',
	TCD: 'Čadská republika',
	MNE: 'Černá Hora',
	CZE: 'Česko',
	CHN: 'Čínská lidová republika',
	DNK: 'Dánsko',
	DMA: 'Dominické společenství',
	DOM: 'Dominikánská republika',
	DJI: 'Džibutská republika',
	EGY: 'Egyptská arabská republika',
	ECU: 'Ekvádorská republika',
	ERI: 'Stát Eritrea',
	EST: 'Estonsko',
	ETH: 'Etiopská federativní demokratická republika',
	FRO: 'Faerské ostrovy',
	FLK: 'Falklandy (Malvíny)',
	FJI: 'Fidžijská republika',
	PHL: 'Filipínská republika',
	FIN: 'Finsko',
	FRA: 'Francie',
	GUF: 'Francouzská Guyana',
	ATF: 'Francouzská jižní a antarktická území',
	PYF: 'Francouzská Polynésie',
	GAB: 'Gabonská republika',
	GMB: 'Gambijská republika',
	GHA: 'Ghanská republika',
	GIB: 'Gibraltar',
	GRD: 'Grenada',
	GRL: 'Grónsko',
	GEO: 'Gruzie',
	GLP: 'Region Guadeloupe',
	GUM: 'Teritorium Guam',
	GTM: 'Guatemalská republika',
	GGY: 'Bailiwick Guernsey',
	GIN: 'Guinejská republika',
	GNB: 'Republika Guinea-Bissau',
	GUY: 'Guyanská kooperativní republika',
	HTI: 'Republika Haiti',
	HMD: 'Heardův ostrov a MacDonaldovy ostrovy',
	HND: 'Honduraská republika',
	HKG: 'Zvláštní administrativní oblast Čínské lidové republiky Hongkong',
	CHL: 'Chilská republika',
	HRV: 'Chorvatsko',
	IND: 'Indická republika',
	IDN: 'Indonéská republika',
	IRQ: 'Irácká republika',
	IRN: 'Íránská islámská republika',
	IRL: 'Irsko',
	ISL: 'Island',
	ITA: 'Itálie',
	ISR: 'Stát Izrael',
	JAM: 'Jamajka',
	JPN: 'Japonsko',
	YEM: 'Jemenská republika',
	JEY: 'Bailiwick Jersey',
	ZAF: 'Jihoafrická republika',
	SGS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
	SSD: 'Jihosúdánská republika',
	JOR: 'Jordánské hášimovské království',
	CYM: 'Kajmanské ostrovy',
	KHM: 'Kambodžské království',
	CMR: 'Kamerunská republika',
	CAN: 'Kanada',
	CPV: 'Kapverdská republika',
	QAT: 'Stát Katar',
	KAZ: 'Republika Kazachstán',
	KEN: 'Keňská republika',
	KIR: 'Republika Kiribati',
	CCK: 'Území Kokosové (Keelingovy) ostrovy',
	COL: 'Kolumbijská republika',
	COM: 'Komorský svaz',
	COD: 'Konžská demokratická republika',
	COG: 'Konžská republika',
	PRK: 'Korejská lidově demokratická republika',
	KOR: 'Korejská republika',
	KSV: 'Kosovo',
	CRI: 'Kostarická republika',
	CUB: 'Kubánská republika',
	KWT: 'Kuvajtský stát',
	CYP: 'Kypr',
	KGZ: 'Kyrgyzská republika',
	LAO: 'Laoská lidově demokratická republika',
	LSO: 'Lesothské království',
	LBN: 'Libanonská republika',
	LBR: 'Liberijská republika',
	LBY: 'Libyjský stát',
	LIE: 'Lichtenštejnsko',
	LTU: 'Litva',
	LVA: 'Lotyšsko',
	LUX: 'Lucembursko',
	MAC: 'Zvláštní administrativní oblast Čínské lidové republiky Macao',
	MDG: 'Madagaskarská republika',
	HUN: 'Maďarsko',
	MYS: 'Malajsie',
	MWI: 'Malawiská republika',
	MDV: 'Maledivská republika',
	MLI: 'Republika Mali',
	MLT: 'Malta',
	IMN: 'Ostrov Man',
	MAR: 'Marocké království',
	MHL: 'Republika Marshallovy ostrovy',
	MTQ: 'Martinik',
	MUS: 'Mauricijská republika',
	MRT: 'Mauritánská islámská republika',
	MYT: 'Departement Mayotte',
	UMI: 'Menší odlehlé ostrovy USA',
	MEX: 'Spojené státy mexické',
	FSM: 'Federativní státy Mikronésie',
	MDA: 'Moldavsko',
	MCO: 'Monako',
	MNG: 'Mongolsko',
	MSR: 'Montserrat',
	MOZ: 'Mosambická republika',
	MMR: 'Republika Myanmarský svaz',
	NAM: 'Namibijská republika',
	NRU: 'Republika Nauru',
	DEU: 'Německo',
	NPL: 'Nepálská federativní demokratická republika',
	NER: 'Nigerská republika',
	NGA: 'Nigerijská federativní republika',
	NIC: 'Nikaragujská republika',
	NIU: 'Niue',
	NLD: 'Nizozemsko',
	NFK: 'Území Norfolk',
	NOR: 'Norsko',
	NCL: 'Nová Kaledonie',
	NZL: 'Nový Zéland',
	OMN: 'Sultanát Omán',
	PAK: 'Pákistánská islámská republika',
	PLW: 'Republika Palau',
	PSE: 'Palestinská autonomní území',
	PAN: 'Panamská republika',
	PNG: 'Nezávislý stát Papua Nová Guinea',
	PRY: 'Paraguayská republika',
	PER: 'Peruánská republika',
	PCN: 'Pitcairnovy ostrovy',
	CIV: 'Republika Pobřeží slonoviny',
	POL: 'Polsko',
	PRI: 'Portorické společenství',
	PRT: 'Portugalsko',
	AUT: 'Rakousko',
	REU: 'Region Réunion',
	GNQ: 'Republika Rovníková Guinea',
	ROU: 'Rumunsko',
	RUS: 'Ruská federace',
	RWA: 'Rwandská republika',
	GRC: 'Řecko',
	SPM: 'Územní společenství Saint Pierre a Miquelon',
	SLV: 'Salvadorská republika',
	WSM: 'Nezávislý stát Samoa',
	SMR: 'San Marino',
	SAU: 'Království Saúdská Arábie',
	SEN: 'Senegalská republika',
	MKD: 'Severní Makedonie',
	MNP: 'Společenství Severní Mariany',
	SYC: 'Seychelská republika',
	SLE: 'Republika Sierra Leone',
	SGP: 'Singapurská republika',
	SVK: 'Slovensko',
	SVN: 'Slovinsko',
	SOM: 'Somálská federativní republika',
	ARE: 'Stát Spojené arabské emiráty',
	USA: 'Spojené státy americké',
	SRB: 'Srbsko',
	CAF: 'Středoafrická republika',
	SDN: 'Súdánská republika',
	SUR: 'Surinamská republika',
	SHN: 'Svatá Helena, Ascension a Tristan da Cunha',
	LCA: 'Svatá Lucie',
	BLM: 'Společenství Svatý Bartoloměj',
	KNA: 'Federace Svatý Kryštof a Nevis',
	MAF: 'Společenství Svatý Martin',
	SXM: 'Svatý Martin (NL)',
	STP: 'Demokratická republika Svatý Tomáš a Princův ostrov',
	VCT: 'Svatý Vincenc a Grenadiny',
	SWZ: 'Svazijské království',
	SYR: 'Syrská arabská republika',
	SLB: 'Šalomounovy ostrovy',
	ESP: 'Španělsko',
	SJM: 'Špicberky a Jan Mayen',
	LKA: 'Šrílanská demokratická socialistická republika',
	SWE: 'Švédsko',
	CHE: 'Švýcarsko',
	TJK: 'Republika Tádžikistán',
	TZA: 'Tanzanská sjednocená republika',
	THA: 'Thajské království',
	TWN: 'Tchaj-wan',
	TGO: 'Tožská republika',
	TKL: 'Tokelau',
	TON: 'Království Tonga',
	TTO: 'Republika Trinidad a Tobago',
	TUN: 'Tuniská republika',
	TUR: 'Turecko',
	TKM: 'Turkmenistán',
	TCA: 'Ostrovy Turks a Caicos',
	TUV: 'Tuvalu',
	UGA: 'Ugandská republika',
	UKR: 'Ukrajina',
	URY: 'Uruguayská východní republika',
	UZB: 'Republika Uzbekistán',
	CXR: 'Území Vánoční ostrov',
	VUT: 'Republika Vanuatu',
	VAT: 'Vatikánský městský stát',
	GBR: 'Spojené království',
	VEN: 'Bolívarovská republika Venezuela',
	VNM: 'Vietnamská socialistická republika',
	TLS: 'Demokratická republika Východní Timor',
	WLF: 'Teritorium Wallisovy ostrovy a Futuna',
	ZMB: 'Zambijská republika',
	ESH: 'Saharská arabská demokratická republika',
	ZWE: 'Zimbabwská republika',
	UNKNOWN: 'Neznámá země',
} satisfies BaseTranslation;

export default cs_countries;
